import { render, staticRenderFns } from "./CombookBindingOrderRow.vue?vue&type=template&id=481eb372&scoped=true&"
import script from "./CombookBindingOrderRow.vue?vue&type=script&lang=ts&"
export * from "./CombookBindingOrderRow.vue?vue&type=script&lang=ts&"
import style0 from "./CombookBindingOrderRow.vue?vue&type=style&index=0&id=481eb372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481eb372",
  null
  
)

export default component.exports